import { render, staticRenderFns } from "./InputField.vue?vue&type=template&id=bfc1c896"
import script from "./InputField.vue?vue&type=script&lang=js"
export * from "./InputField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfc1c896')) {
      api.createRecord('bfc1c896', component.options)
    } else {
      api.reload('bfc1c896', component.options)
    }
    module.hot.accept("./InputField.vue?vue&type=template&id=bfc1c896", function () {
      api.rerender('bfc1c896', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth2/shared/InputField.vue"
export default component.exports